import '../styles/style.css'; 
import logo from '../imagens/logo.png'; 
import tombstoneIcon from '../imagens/tombstone.gif';
import editIcon from '../imagens/edit.gif';
import truckIcon from '../imagens/pickup-truck.gif';
import image from '../imagens/4.jpg';
import Navbar from '../components/navbar'; 
import Footer from '../components/footer'; 

const Home = () => {
    return (
        <>
            {/* Secção de Boas-Vindas */}
            <header className="hero">
                <Navbar /> 
                <div className="hero-content">
                    <h1 className="hero-title">Especialistas na criação de Pedras de Campas</h1>
                    <p className="hero-subtitle">Qualidade e Respeito em Cada Detalhe</p>
                </div>
            </header>

            {/* Secção Quem Somos */}
            <section id="quem-somos" className="sobre-mim">
                <div className="container text-center">
                    <h1 className="quemsomos">Quem Somos</h1>
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <div className="image-container">
                                <img src={image} alt="Foto da Equipa" className="profile-img" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="bio-content">
                                <p className="bio-text">
                                    Somos a <strong>GR Mármores</strong>, especialistas na fabricação de pedras para campas.
                                    Nosso compromisso é oferecer produtos de alta qualidade, garantindo respeito e carinho em cada peça.
                                </p>
                                <p className="bio-text">
                                    Com anos de experiência e um olhar atento aos detalhes, ajudamos famílias a homenagear seus entes queridos
                                    com peças únicas e personalizadas.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* Secção Nossos Serviços */}
            <section id="nossos-servicos" className="trabalhos">
                <div className="container">
                    <h1>Nossos Serviços</h1>
                    <div className="row">
                        <div className="col-md-4 work-item">
                            <div className="work-icon">
                                <img src={tombstoneIcon} alt="Fabricação de Pedras" className="animated_icons" />
                            </div>
                            <h2>Fabricação de Pedras</h2>
                        </div>
                        <div className="col-md-4 work-item">
                            <div className="work-icon">
                                <img src={editIcon} alt="Personalização" className="animated_icons" />
                            </div>
                            <h2>Personalização</h2>
                        </div>
                        <div className="col-md-4 work-item">
                            <div className="work-icon">
                                <img src={truckIcon} alt="Entrega e Instalação" className="animated_icons" />
                            </div>
                            <h2>Entrega e Instalação</h2>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </>
    );
};

export default Home;
